var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H21.9844C27.5073 0 31.9844 4.47715 31.9844 10V21.9844C31.9844 27.5073 27.5073 31.9844 21.9844 31.9844H10C4.47715 31.9844 0 27.5073 0 21.9844V10Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8001_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3176 22.4722C15.5201 22.5891 15.7498 22.6506 15.9836 22.6506C16.2174 22.6506 16.4471 22.5891 16.6496 22.4722L21.3115 19.8083C21.5138 19.6915 21.6818 19.5235 21.7987 19.3213C21.9156 19.1191 21.9772 18.8897 21.9775 18.6561V13.3282C21.9772 13.0946 21.9156 12.8652 21.7987 12.663C21.6818 12.4608 21.5138 12.2929 21.3115 12.1761L16.6496 9.51213C16.4471 9.39522 16.2174 9.33368 15.9836 9.33368C15.7498 9.33368 15.5201 9.39522 15.3176 9.51213L10.6557 12.1761C10.4534 12.2929 10.2854 12.4608 10.1685 12.663C10.0516 12.8652 9.98999 13.0946 9.98975 13.3282V18.6561C9.98999 18.8897 10.0516 19.1191 10.1685 19.3213C10.2854 19.5235 10.4534 19.6915 10.6557 19.8083L15.3176 22.4722Z",
    stroke: "#155DFC",
    strokeWidth: 1.33197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9836 22.652V15.9922",
    stroke: "#155DFC",
    strokeWidth: 1.33197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1829 12.6622L15.9837 15.9922L21.7844 12.6622",
    stroke: "#155DFC",
    strokeWidth: 1.33197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9867 10.8441L18.9806 14.2739",
    stroke: "#155DFC",
    strokeWidth: 1.33197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8001_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9836,
    height: 15.9836,
    fill: "white",
    transform: "translate(7.99182 8.00037)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.8aa6202ed380650444e72b2f15717a14.svg";
export { ForwardRef as ReactComponent };